/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4DiagMinIcon20Light = forwardRef('ArrowDim4DiagMinIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.354 2.354 13.707 7H17.5a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 12 6.5v-4a.5.5 0 0 1 1 0v3.793l4.646-4.647a.5.5 0 0 1 .708.708Z" }),
        React.createElement("path", { d: "m7 13.707-4.646 4.647a.5.5 0 0 1-.708-.708L6.293 13H2.5a.5.5 0 0 1 0-1h4A1.5 1.5 0 0 1 8 13.5v4a.5.5 0 0 1-1 0v-3.793Z" }),
        React.createElement("path", { d: "M17.5 13h-3.793l4.647 4.646a.5.5 0 0 1-.708.708L13 13.707V17.5a.5.5 0 0 1-1 0v-4a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 0 1 0 1Z" }),
        React.createElement("path", { d: "M2.354 1.646a.5.5 0 1 0-.708.708L6.293 7H2.5a.5.5 0 0 0 0 1h4A1.5 1.5 0 0 0 8 6.5v-4a.5.5 0 0 0-1 0v3.793L2.354 1.646Z" })));
});
